import SGSFormInput from './Input';
import SGSFormInputMask from './InputMask';
import SGSFormTextarea from './Textarea';
import SGSFormFileInput from './FileInput';
import SGSFormSelect from './Select';
import SGSFormCheckbox from './Checkbox';
import SGSFormDate from './Date';
import SGSFormWysiwyg from './Wysiwyg';
export { default as SGSFormLayout, SGSForm } from './Layout';
export { default as SGSFormSwitch } from './Switch';

// Quelques types pour faciliter l'écriture des formulaires de création / édition,
// il faudrait sûrement faire un composant plus générique ou plus haut qui utiliserait
// ces types à terme. Pour le moment, je les mets ici.

export type FormCreateProps<T> = { onCreate(data: T): void };
export type FormEditProps<T> = { onEdit(data: T): void };
export type FormCallbacksProps<T> = FormCreateProps<T> | FormEditProps<T>;
export type FormCommonProps<T> = {
    defaultValues?: Partial<T>;
};
export type FormProps<T> = FormCallbacksProps<T> & FormCommonProps<T>;

/**
 * Type guard pour déterminer si un formulaire est en création ou édition.
 */
export function isCreation<T>(props: FormCallbacksProps<T>): props is FormCreateProps<T> {
    if ((props as any).onCreate) {
        return true;
    }

    return false;
}

export {
    SGSFormInput,
    SGSFormInputMask,
    SGSFormTextarea,
    SGSFormFileInput,
    SGSFormSelect,
    SGSFormCheckbox,
    SGSFormDate,
    SGSFormWysiwyg,
};
export { default as FormPage } from './FormPage';
export { default as SGSFormRadio } from './Radio';
